import { render, staticRenderFns } from "./UiCloseButton.vue?vue&type=template&id=2f4f34dc"
import script from "./UiCloseButton.vue?vue&type=script&lang=js"
export * from "./UiCloseButton.vue?vue&type=script&lang=js"
import style0 from "./UiCloseButton.vue?vue&type=style&index=0&id=2f4f34dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports